var map = {
	"./account-statement.svg": 217702,
	"./audits.svg": 384289,
	"./bag-icon.svg": 469133,
	"./bar-report.svg": 907775,
	"./bars.svg": 539839,
	"./bookings.svg": 318009,
	"./business-inteligence.svg": 919929,
	"./business-intelligence-v2.svg": 354642,
	"./cargo-cart.svg": 394246,
	"./cash-flow.svg": 876913,
	"./change-language.svg": 415028,
	"./chart-of-accounts-v2.svg": 834753,
	"./chart-of-accounts.svg": 841200,
	"./clients.svg": 745527,
	"./communication.svg": 375103,
	"./config-adm.svg": 843404,
	"./contract.svg": 41759,
	"./crm.svg": 656531,
	"./customers.svg": 294564,
	"./dashboard-chart.svg": 931984,
	"./delivery-person-white.svg": 781833,
	"./delivery.svg": 2065,
	"./devices.svg": 520610,
	"./employee.svg": 116121,
	"./events.svg": 924426,
	"./file-check.svg": 46864,
	"./financial-report.svg": 925765,
	"./financial.svg": 217322,
	"./fiscal.svg": 618143,
	"./giftback.svg": 534110,
	"./help.svg": 198424,
	"./kds.svg": 535479,
	"./list-multiple.svg": 375762,
	"./logout.svg": 89399,
	"./loyalty.svg": 714525,
	"./megaphone.svg": 899197,
	"./multivendor-v2.svg": 512603,
	"./multivendor.svg": 980646,
	"./new-storage.svg": 15205,
	"./operation.svg": 775624,
	"./packages.svg": 778170,
	"./panel.svg": 667377,
	"./password-card.svg": 654813,
	"./pdv-status.svg": 684748,
	"./place.svg": 359214,
	"./pos-machine.svg": 983737,
	"./pre-charge.svg": 954617,
	"./products.svg": 35121,
	"./promotions.svg": 163771,
	"./receptive.svg": 261764,
	"./recharge-management.svg": 114354,
	"./report.svg": 777439,
	"./reports.svg": 941854,
	"./reserve.svg": 923959,
	"./satisfaction-survey.svg": 604108,
	"./sell-with-no-card.svg": 226413,
	"./settings.svg": 92130,
	"./stock-inventory.svg": 181638,
	"./storage-reports.svg": 748338,
	"./table-config.svg": 399066,
	"./table-report.svg": 1574,
	"./tax-data.svg": 506705,
	"./tax.svg": 255140,
	"./team.svg": 720110,
	"./tickets-report.svg": 969635,
	"./tickets-v2.svg": 146961,
	"./tickets.svg": 855776,
	"./users.svg": 801579,
	"./whats-up.svg": 107220,
	"./zig-account.svg": 693911,
	"./zig-tag.svg": 704422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284537;